var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pt-0" },
        [
          _c(
            "v-col",
            { staticClass: "px-0", staticStyle: { "z-index": "0" } },
            [
              _c("div", { staticClass: "mt-0 pa-0 d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "pa-0",
                    staticStyle: { flex: "0", "min-width": "350px" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "fixed!important" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-0 pb-16",
                            attrs: {
                              flat: "",
                              width: "350",
                              height: "calc(100vh - 220px)",
                            },
                          },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          align: "center",
                                          "no-gutters": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "18",
                                              left: "",
                                              color: "grey-700",
                                            },
                                          },
                                          [_vm._v("mdi-account")]
                                        ),
                                        _vm._v(" Usuario "),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c(
                              "v-card-text",
                              {
                                staticClass: "pa-0",
                                staticStyle: {
                                  "min-height": "calc(100vh - 485px)",
                                },
                              },
                              [
                                _vm.loadingMembers
                                  ? _c("skeleton-groups", {
                                      staticClass: "mt-5",
                                      attrs: { type: "inf" },
                                    })
                                  : _c(
                                      "v-list",
                                      {
                                        staticClass:
                                          "v-list-form-extended-medium transparent py-5 px-5",
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-700--text font-weight-semibold pb-2",
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                attrs: {
                                                  align: "center",
                                                  "no-gutters": "",
                                                },
                                              },
                                              [_vm._v(" Información básica ")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "py-2" },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v("Nombre"),
                                            ]),
                                            _c(
                                              "v-list-item-subtitle",
                                              [
                                                _vm.loadingMembers
                                                  ? _c("v-avatar", {
                                                      staticClass:
                                                        "placeholder rounded-pill ml-1",
                                                      attrs: {
                                                        tile: "",
                                                        height: "15",
                                                        width: "220",
                                                      },
                                                    })
                                                  : [
                                                      ["", " "].includes(
                                                        _vm.editable.name
                                                      )
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 text--disabled font-italic",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Sin especificar"
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-capitalize grey-300--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "lower"
                                                                    )(
                                                                      _vm
                                                                        .editable
                                                                        .name
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "mt-0" },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v("Email"),
                                            ]),
                                            _c(
                                              "v-list-item-subtitle",
                                              [
                                                _vm.loadingMembers
                                                  ? _c("v-avatar", {
                                                      staticClass:
                                                        "placeholder rounded-pill ml-1",
                                                      attrs: {
                                                        tile: "",
                                                        height: "15",
                                                        width: "280",
                                                      },
                                                    })
                                                  : [
                                                      _vm.editable.email
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.editable
                                                                      .email
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 text--disabled font-italic",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Sin especificar"
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c("v-divider", {
                              staticClass: "mx-6",
                              class: { "mt-n7": _vm.loadingMembers },
                            }),
                            _c(
                              "v-card-actions",
                              {
                                staticClass: "px-5 pt-5",
                                staticStyle: { display: "block" },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "d-block body-1 grey-300--text",
                                  },
                                  [
                                    _vm._v(
                                      " ¿Qué ocurre cuando se desactiva un usuarios? "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "d-block mt-4" },
                                      [
                                        _vm._v(
                                          "1. El usuario ya no podrá trabajar en el espacio de trabajo."
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "d-block mt-2 pb-2" },
                                      [
                                        _vm._v(
                                          "2. Toda la información creada por el usuario seguirá estando disponible."
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.$helpers.hasPermission(["delete_member"])
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticStyle: {
                                          border:
                                            "1px solid var(--light-red-500) !important",
                                        },
                                        attrs: { outlined: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.dialogDelete = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "red-500--text" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  color:
                                                    "var(--light-red-500) !important",
                                                },
                                              },
                                              [_vm._v("mdi-account-off")]
                                            ),
                                            _vm._v(" Desactivar usuario "),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pa-0 pb-16 ml-8",
                    staticStyle: { flex: "1", "min-width": "350px" },
                  },
                  [
                    _c(
                      "v-toolbar",
                      {
                        attrs: { color: "transparent", flat: "", height: "36" },
                      },
                      [
                        _c(
                          "v-toolbar-title",
                          {
                            staticClass:
                              "subtitle-1 grey-700--text font-weight-semibold",
                          },
                          [
                            _c(
                              "v-row",
                              { attrs: { align: "center", "no-gutters": "" } },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "18",
                                      left: "",
                                      color: "grey-700",
                                    },
                                  },
                                  [_vm._v("mdi-account")]
                                ),
                                _vm._v(" Permisos del usuario "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-toolbar-items",
                          [
                            _vm.$route.name === "AccountGroupsUpdate"
                              ? _c(
                                  "v-row",
                                  {
                                    staticClass: "mr-3",
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { outlined: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.dialogPermissions = true
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v("mdi-account-group"),
                                        ]),
                                        _vm._v(" Lista de usuarios "),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "mt-2",
                        attrs: { align: "start", "no-gutters": "" },
                      },
                      [
                        _c(
                          "v-col",
                          { staticClass: "px-0" },
                          [
                            _c(
                              "v-card",
                              { staticClass: "pa-0", attrs: { flat: "" } },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "v-toolbar",
                                      {
                                        attrs: {
                                          color: "transparent",
                                          flat: "",
                                          height: "46",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          {
                                            staticClass:
                                              "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                attrs: {
                                                  align: "center",
                                                  "no-gutters": "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "18",
                                                      left: "",
                                                      color: "grey-700",
                                                    },
                                                  },
                                                  [_vm._v("mdi-account-group")]
                                                ),
                                                _vm._v(" Roles "),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-spacer"),
                                        _c(
                                          "v-toolbar-items",
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "mr-6",
                                                attrs: {
                                                  align: "center",
                                                  justify: "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      text: "",
                                                      color: "grey-900",
                                                      to: {
                                                        name: "AccountGroupsCreate",
                                                        params:
                                                          _vm.currentParams,
                                                      },
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v(" Crear nuevo rol ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c(
                                      "v-card-text",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "px-5" },
                                          [
                                            _vm.loading || _vm.loadingMembers
                                              ? _c("skeleton-groups", {
                                                  attrs: {
                                                    type: "permissions",
                                                  },
                                                })
                                              : [
                                                  _vm.currentGroupsList.length
                                                    ? _vm._l(
                                                        _vm.currentGroupsList,
                                                        function (
                                                          group,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "pa-0",
                                                            },
                                                            [
                                                              _c(
                                                                "v-list",
                                                                {
                                                                  staticClass:
                                                                    "v-list-1 transparent pa-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 py-2",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "grey-300--text",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  text: "",
                                                                                  color:
                                                                                    "grey-900",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.handleGroup(
                                                                                      group
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  group.name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mt-n1",
                                                                            },
                                                                            [
                                                                              group.description
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "body-2 d-inline-block text-truncate",
                                                                                      staticStyle:
                                                                                        {
                                                                                          "max-width":
                                                                                            "80%",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          group.description
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-block body-2 text--disabled font-italic",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Sin especificar"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "v-list-item-subtitle",
                                                                        [
                                                                          _c(
                                                                            "v-switch",
                                                                            {
                                                                              staticClass:
                                                                                "mt-n1",
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    "green-500",
                                                                                  ripple: false,
                                                                                  "hide-details":
                                                                                    "",
                                                                                  absolute:
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    ;(_vm.isChangeList = true),
                                                                                      _vm.setPermissionsByGroups(
                                                                                        group
                                                                                      )
                                                                                  },
                                                                              },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    group.active,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        group,
                                                                                        "active",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "group.active",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    : _c("v-empty-state", {
                                                        staticClass: "mt-n3",
                                                        attrs: {
                                                          type: "groups",
                                                          id: "groups",
                                                          isFree: true,
                                                          title:
                                                            "No existen roles",
                                                          customClass: "mt-5",
                                                          height: 200,
                                                        },
                                                      }),
                                                ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.loadingDetail
                      ? _c(
                          "v-col",
                          { staticClass: "pa-0" },
                          [
                            _c("v-skeleton-loader", {
                              staticClass: "skeleton-group rounded-t-md",
                              attrs: {
                                tile: "",
                                transition: "fade-transition",
                                type: "image",
                                height: 200,
                              },
                            }),
                            _c("v-divider"),
                            _c("v-skeleton-loader", {
                              staticClass: "skeleton-group",
                              attrs: {
                                tile: "",
                                transition: "fade-transition",
                                type: "image",
                                height: 200,
                              },
                            }),
                            _c("v-divider"),
                            _c("v-skeleton-loader", {
                              staticClass: "skeleton-group rounded-b-md",
                              attrs: {
                                tile: "",
                                transition: "fade-transition",
                                type: "image",
                                height: 200,
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "v-row",
                          {
                            staticClass: "mt-5",
                            attrs: { align: "start", "no-gutters": "" },
                          },
                          [
                            _c(
                              "v-col",
                              { staticClass: "px-0" },
                              _vm._l(_vm.list, function (item, i) {
                                return _c(
                                  "v-card",
                                  {
                                    key: i,
                                    staticClass: "pa-0",
                                    class: item.parent
                                      ? _vm.roundedByCategory(item.category)
                                      : "my-5",
                                    attrs: { flat: "" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        item.parent === "Configuraciones" &&
                                        item.category === "Organización"
                                          ? [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  attrs: {
                                                    color: "transparent",
                                                    flat: "",
                                                    height: "46",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-toolbar-title",
                                                    {
                                                      staticClass:
                                                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "18",
                                                                left: "",
                                                                color:
                                                                  "grey-700",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-file-document"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " Configuración "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                            ]
                                          : _vm._e(),
                                        item.parent === "Recepción" &&
                                        item.category === "Documentos"
                                          ? [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  attrs: {
                                                    color: "transparent",
                                                    flat: "",
                                                    height: "46",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-toolbar-title",
                                                    {
                                                      staticClass:
                                                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "18",
                                                                left: "",
                                                                color:
                                                                  "grey-700",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-file-document"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" Recepción "),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "v-toolbar",
                                          {
                                            attrs: {
                                              color: "transparent",
                                              flat: "",
                                              height: "46",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-toolbar-title",
                                              {
                                                staticClass:
                                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    attrs: {
                                                      align: "center",
                                                      "no-gutters": "",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          size: "18",
                                                          left: "",
                                                          color: "grey-700",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-" +
                                                            _vm._s(item.icon)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.category ===
                                                            "SII"
                                                            ? _vm.$t(
                                                                "generals.SII"
                                                              )
                                                            : item.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-text",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "px-5" },
                                              [
                                                _vm.loadingDetail
                                                  ? _c("skeleton-groups", {
                                                      attrs: {
                                                        type: "permissions",
                                                      },
                                                    })
                                                  : _vm._l(
                                                      item.children,
                                                      function (c, index) {
                                                        return _c(
                                                          "v-col",
                                                          {
                                                            key: index,
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list",
                                                              {
                                                                staticClass:
                                                                  "v-list-1 transparent pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0 ma-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-300--text",
                                                                      },
                                                                      [
                                                                        c.key !==
                                                                        "dtes"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      c.name
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                                c
                                                                                  .assignedByGroups
                                                                                  ?.length
                                                                                  ? _c(
                                                                                      "v-chip",
                                                                                      {
                                                                                        staticClass:
                                                                                          "caption pa-2 ml-2",
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "blue-50",
                                                                                            "text-color":
                                                                                              "blue-200",
                                                                                            "x-small":
                                                                                              "",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " Asignado a través del rol “ "
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "d-inline-block text-truncate",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "max-width":
                                                                                                  "200px",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            c
                                                                                              .assignedByGroups
                                                                                              .length >
                                                                                            2
                                                                                              ? [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      c.assignedByGroups
                                                                                                        .slice(
                                                                                                          0,
                                                                                                          2
                                                                                                        )
                                                                                                        .toString()
                                                                                                        .replace(
                                                                                                          ",",
                                                                                                          ", "
                                                                                                        )
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              : [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      c.assignedByGroups
                                                                                                        .toString()
                                                                                                        .replace(
                                                                                                          ",",
                                                                                                          " y "
                                                                                                        )
                                                                                                    )
                                                                                                  ),
                                                                                                ],
                                                                                          ],
                                                                                          2
                                                                                        ),
                                                                                        c
                                                                                          .assignedByGroups
                                                                                          .length >
                                                                                        2
                                                                                          ? _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "ml-1",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " y " +
                                                                                                    _vm._s(
                                                                                                      c
                                                                                                        .assignedByGroups
                                                                                                        .length -
                                                                                                        2
                                                                                                    ) +
                                                                                                    " " +
                                                                                                    _vm._s(
                                                                                                      c
                                                                                                        .assignedByGroups
                                                                                                        .length -
                                                                                                        2 !==
                                                                                                        1
                                                                                                        ? "roles"
                                                                                                        : "rol"
                                                                                                    ) +
                                                                                                    " más "
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                        _vm._v(
                                                                                          "” "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : [
                                                                                      "Resúmenes",
                                                                                      "Emisión por lotes",
                                                                                      "Cuadratura",
                                                                                      "Clientes",
                                                                                    ].includes(
                                                                                      c.category
                                                                                    )
                                                                                  ? [
                                                                                      c.name.includes(
                                                                                        "Ver"
                                                                                      ) &&
                                                                                      item
                                                                                        .children[
                                                                                        index -
                                                                                          1
                                                                                      ]
                                                                                        ?.active
                                                                                        ? _c(
                                                                                            "v-chip",
                                                                                            {
                                                                                              staticClass:
                                                                                                "caption pa-2",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "blue-50",
                                                                                                  "text-color":
                                                                                                    "blue-200",
                                                                                                  "x-small":
                                                                                                    "",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  class:
                                                                                                    {
                                                                                                      "d-inline-block text-truncate":
                                                                                                        _vm
                                                                                                          .$vuetify
                                                                                                          .breakpoint
                                                                                                          .width <
                                                                                                        1310,
                                                                                                    },
                                                                                                  style: `max-width: ${
                                                                                                    _vm
                                                                                                      .$vuetify
                                                                                                      .breakpoint
                                                                                                      .width <
                                                                                                    1310
                                                                                                      ? "300px"
                                                                                                      : "auto"
                                                                                                  };`,
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Obligatorio, si la opción " +
                                                                                                      _vm._s(
                                                                                                        item.children[
                                                                                                          index -
                                                                                                            1
                                                                                                        ].name.toLowerCase()
                                                                                                      ) +
                                                                                                      " está activa "
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  : _vm._e(),
                                                                              ],
                                                                              2
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        c.key !==
                                                                        "dtes"
                                                                          ? _c(
                                                                              "v-switch",
                                                                              {
                                                                                staticClass:
                                                                                  "mt-n1",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "green-500",
                                                                                    ripple: false,
                                                                                    "hide-details":
                                                                                      "",
                                                                                    disabled:
                                                                                      !!c
                                                                                        .assignedByGroups
                                                                                        ?.length ||
                                                                                      item
                                                                                        .children[
                                                                                        index -
                                                                                          1
                                                                                      ]
                                                                                        ?.active,
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.handlerChange(
                                                                                        c,
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      c.active,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          c,
                                                                                          "active",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "c.active",
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                c.key === "dtes"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "mt-n7",
                                                                      },
                                                                      [
                                                                        _vm._l(
                                                                          _vm.currentDocumentList,
                                                                          function (
                                                                            doc,
                                                                            i
                                                                          ) {
                                                                            return _c(
                                                                              "v-list-item",
                                                                              {
                                                                                key: i,
                                                                                staticClass:
                                                                                  "pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    inactive:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list-item-title",
                                                                                  {
                                                                                    staticClass:
                                                                                      "grey-300--text",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          doc.name
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                    doc
                                                                                      .assignedByGroups
                                                                                      ?.length &&
                                                                                    doc.active
                                                                                      ? _c(
                                                                                          "v-chip",
                                                                                          {
                                                                                            staticClass:
                                                                                              "caption pa-2 mx-2",
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "blue-50",
                                                                                                "text-color":
                                                                                                  "blue-200",
                                                                                                "x-small":
                                                                                                  "",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " Asignado a través del rol “ "
                                                                                            ),
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-inline-block text-truncate",
                                                                                                staticStyle:
                                                                                                  {
                                                                                                    "max-width":
                                                                                                      "200px",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                doc
                                                                                                  .assignedByGroups
                                                                                                  .length >
                                                                                                2
                                                                                                  ? [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          doc.assignedByGroups
                                                                                                            .slice(
                                                                                                              0,
                                                                                                              2
                                                                                                            )
                                                                                                            .toString()
                                                                                                            .replace(
                                                                                                              ",",
                                                                                                              ", "
                                                                                                            )
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  : [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          doc.assignedByGroups
                                                                                                            .toString()
                                                                                                            .replace(
                                                                                                              ",",
                                                                                                              " y "
                                                                                                            )
                                                                                                        )
                                                                                                      ),
                                                                                                    ],
                                                                                              ],
                                                                                              2
                                                                                            ),
                                                                                            doc
                                                                                              .assignedByGroups
                                                                                              .length >
                                                                                              2 &&
                                                                                            doc.name.includes(
                                                                                              "Crear"
                                                                                            )
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "ml-1",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      " y " +
                                                                                                        _vm._s(
                                                                                                          doc
                                                                                                            .assignedByGroups
                                                                                                            .length -
                                                                                                            2
                                                                                                        ) +
                                                                                                        " " +
                                                                                                        _vm._s(
                                                                                                          c
                                                                                                            .assignedByGroups
                                                                                                            .length -
                                                                                                            2 !==
                                                                                                            1
                                                                                                            ? "roles"
                                                                                                            : "rol"
                                                                                                        ) +
                                                                                                        " más "
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm._v(
                                                                                              "” "
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    doc.name.includes(
                                                                                      "Ver"
                                                                                    ) &&
                                                                                    _vm
                                                                                      .currentDocumentList[
                                                                                      i -
                                                                                        1
                                                                                    ]
                                                                                      ?.active &&
                                                                                    doc.active
                                                                                      ? _c(
                                                                                          "v-chip",
                                                                                          {
                                                                                            staticClass:
                                                                                              "caption pa-2 mr-2",
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "blue-50",
                                                                                                "text-color":
                                                                                                  "blue-200",
                                                                                                "x-small":
                                                                                                  "",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-inline-block text-truncate",
                                                                                                staticStyle:
                                                                                                  {
                                                                                                    "max-width":
                                                                                                      "200px",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " Obligatorio, si la opción " +
                                                                                                    _vm._s(
                                                                                                      _vm.currentDocumentList[
                                                                                                        i -
                                                                                                          1
                                                                                                      ].name.toLowerCase()
                                                                                                    ) +
                                                                                                    " está activa "
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _c(
                                                                                  "v-list-item-subtitle",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mr-0",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-switch",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mt-n1",
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "green-500",
                                                                                            ripple: false,
                                                                                            disabled:
                                                                                              (doc.name.includes(
                                                                                                "Ver"
                                                                                              ) &&
                                                                                                _vm
                                                                                                  .currentDocumentList[
                                                                                                  i -
                                                                                                    1
                                                                                                ]
                                                                                                  ?.active) ||
                                                                                              !!doc
                                                                                                .assignedByGroups
                                                                                                ?.length,
                                                                                            "hide-details":
                                                                                              "",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              ;(item.selectOrDeselectAllPermission =
                                                                                                _vm.currentDocumentList.every(
                                                                                                  (
                                                                                                    item
                                                                                                  ) =>
                                                                                                    item?.active
                                                                                                )),
                                                                                                _vm.enabledTooltip(
                                                                                                  doc,
                                                                                                  i,
                                                                                                  index
                                                                                                )
                                                                                            },
                                                                                          change:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.isChangeList = true
                                                                                            },
                                                                                        },
                                                                                        model:
                                                                                          {
                                                                                            value:
                                                                                              doc.active,
                                                                                            callback:
                                                                                              function (
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  doc,
                                                                                                  "active",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                            expression:
                                                                                              "doc.active",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          }
                                                                        ),
                                                                        item.category ===
                                                                        "Emisión"
                                                                          ? _c(
                                                                              "v-col",
                                                                              {
                                                                                class:
                                                                                  [
                                                                                    "pa-0 mt-2",
                                                                                    {
                                                                                      "mb-6":
                                                                                        _vm
                                                                                          .$store
                                                                                          .state
                                                                                          .auth
                                                                                          .account
                                                                                          .country !==
                                                                                        "PE",
                                                                                    },
                                                                                  ],
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list",
                                                                                  {
                                                                                    staticClass:
                                                                                      "v-list-1 transparent pa-0",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-list-item",
                                                                                      {
                                                                                        staticClass:
                                                                                          "pa-0",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-list-item-title",
                                                                                          {
                                                                                            staticClass:
                                                                                              "font-weight-bold grey-300--text",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Seleccionar todos los DTE’s"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "v-list-item-subtitle",
                                                                                          [
                                                                                            _c(
                                                                                              "v-switch",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mt-n1",
                                                                                                attrs:
                                                                                                  {
                                                                                                    disabled:
                                                                                                      _vm.currentDocumentList
                                                                                                        .filter(
                                                                                                          (
                                                                                                            d
                                                                                                          ) =>
                                                                                                            d.name.includes(
                                                                                                              "Crear"
                                                                                                            )
                                                                                                        )
                                                                                                        .every(
                                                                                                          (
                                                                                                            dte
                                                                                                          ) =>
                                                                                                            dte?.active &&
                                                                                                            !!dte
                                                                                                              .assignedByGroups
                                                                                                              ?.length
                                                                                                        ),
                                                                                                    color:
                                                                                                      "green-500",
                                                                                                    ripple: false,
                                                                                                    "hide-details":
                                                                                                      "",
                                                                                                  },
                                                                                                on: {
                                                                                                  change:
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      ;(_vm.isChangeList = true),
                                                                                                        _vm.selectAllPermissions(
                                                                                                          item.category,
                                                                                                          $event
                                                                                                        )
                                                                                                    },
                                                                                                },
                                                                                                model:
                                                                                                  {
                                                                                                    value:
                                                                                                      item.selectOrDeselectAllPermission,
                                                                                                    callback:
                                                                                                      function (
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "selectOrDeselectAllPermission",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                    expression:
                                                                                                      "item.selectOrDeselectAllPermission",
                                                                                                  },
                                                                                              }
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm
                                                                          .$store
                                                                          .state
                                                                          .auth
                                                                          .account
                                                                          .country !==
                                                                        "PE"
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "mt-n3",
                                                                                staticStyle:
                                                                                  {
                                                                                    "border-top":
                                                                                      "1px solid var(--light-grey-50)",
                                                                                    position:
                                                                                      "absolute",
                                                                                    width:
                                                                                      "100%",
                                                                                    left: "0",
                                                                                    right:
                                                                                      "0",
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.list.length - 1 !== i &&
                                        (["Configuraciones"].includes(
                                          item.parent
                                        ) ||
                                          [
                                            "Documentos",
                                            "Emisión",
                                            "Emisión por lotes",
                                            "Cuadratura",
                                            "Resúmenes",
                                            "Clientes",
                                          ].includes(item.category))
                                          ? _c("v-divider")
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "text-end grey-background mt-6 pa-0 pagination-permissions",
        },
        [
          _c("v-divider"),
          _c(
            "v-col",
            { staticClass: "px-0" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "px-4",
                  attrs: {
                    to: { name: "AccountMembers", params: this.$route.params },
                    outlined: "",
                  },
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "px-4 ml-2 mr-6",
                  attrs: {
                    loading: _vm.loadingUpdate,
                    disabled: !_vm.isChangeList,
                    color: "grey-900",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.update()
                    },
                  },
                },
                [_vm._v(" Guardar usuario ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "751",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDelete,
            callback: function ($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Desactivar usuarios")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogDelete = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-member.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-0 py-5" },
                        [
                          _c("span", { staticClass: "d-block" }, [
                            _vm._v(
                              "¿Qué ocurre cuando se desactiva un usuario?"
                            ),
                          ]),
                          _c("span", { staticClass: "d-block mt-4" }, [
                            _vm._v(
                              "1. El usuario ya no podrá trabajar en el espacio de trabajo."
                            ),
                          ]),
                          _c("span", { staticClass: "d-block mt-2 mb-3" }, [
                            _vm._v(
                              "2. Toda la información creada por el usuario seguirá estando disponible."
                            ),
                          ]),
                          _c("span", { staticClass: "d-block mt-4 mb-3" }, [
                            _vm._v("Escribe "),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("“confirmar”"),
                            ]),
                            _vm._v(" para continuar."),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDelete = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.deleteMember },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "500",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
            scrollable: true,
          },
          model: {
            value: _vm.dialogPermissions,
            callback: function ($$v) {
              _vm.dialogPermissions = $$v
            },
            expression: "dialogPermissions",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { "max-height": "600" } },
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v(_vm._s(_vm.currentGroup.name))]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: {
                                align: "center",
                                justify: "center",
                                "no-gutters": "",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.handlerGroupDialog },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "pa-0 grey-500--text",
                  staticStyle: { "min-height": "360px" },
                },
                [
                  _vm.loadingDetailByGroup
                    ? _c(
                        "v-col",
                        { staticClass: "pa-0" },
                        [
                          _c("v-skeleton-loader", {
                            staticClass: "skeleton-group rounded-t-md",
                            attrs: {
                              tile: "",
                              transition: "fade-transition",
                              type: "image",
                              height: 200,
                            },
                          }),
                          _c("v-divider"),
                          _c("v-skeleton-loader", {
                            staticClass: "skeleton-group",
                            attrs: {
                              tile: "",
                              transition: "fade-transition",
                              type: "image",
                              height: 200,
                            },
                          }),
                          _c("v-divider"),
                          _c("v-skeleton-loader", {
                            staticClass: "skeleton-group rounded-b-md",
                            attrs: {
                              tile: "",
                              transition: "fade-transition",
                              type: "image",
                              height: 200,
                            },
                          }),
                        ],
                        1
                      )
                    : [
                        _vm.currentGroup?.list?.length
                          ? _c(
                              "v-row",
                              { attrs: { align: "start", "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "px-0" },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass: "pa-0",
                                        attrs: { flat: "" },
                                      },
                                      _vm._l(
                                        _vm.currentGroup.list,
                                        function (item, i) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  attrs: {
                                                    color: "transparent",
                                                    flat: "",
                                                    height: "46",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-toolbar-title",
                                                    {
                                                      staticClass:
                                                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "18",
                                                                left: "",
                                                                color:
                                                                  "grey-700",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-" +
                                                                  _vm._s(
                                                                    item.icon
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.category ===
                                                                  "SII"
                                                                  ? _vm.$t(
                                                                      "generals.SII"
                                                                    )
                                                                  : item.category
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-card-text",
                                                { staticClass: "pa-0" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { staticClass: "px-5" },
                                                    [
                                                      _vm.loadingDetail
                                                        ? _c(
                                                            "skeleton-groups",
                                                            {
                                                              attrs: {
                                                                type: "permissions",
                                                              },
                                                            }
                                                          )
                                                        : _vm._l(
                                                            item.children,
                                                            function (
                                                              c,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "v-col",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "pa-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list",
                                                                    {
                                                                      staticClass:
                                                                        "v-list-1 transparent pa-0",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "grey-300--text",
                                                                            },
                                                                            [
                                                                              c.key !==
                                                                              "dtes"
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          c.name
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              c.key !==
                                                                              "dtes"
                                                                                ? _c(
                                                                                    "v-switch",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mt-n1",
                                                                                      attrs:
                                                                                        {
                                                                                          color:
                                                                                            "green-500",
                                                                                          ripple: false,
                                                                                          "hide-details":
                                                                                            "",
                                                                                          disabled:
                                                                                            "",
                                                                                          dense:
                                                                                            "",
                                                                                        },
                                                                                      on: {
                                                                                        change:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            item.selectOrDeselectAllPermission =
                                                                                              item.children.every(
                                                                                                (
                                                                                                  item
                                                                                                ) =>
                                                                                                  item.active
                                                                                              )
                                                                                          },
                                                                                      },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            c.active,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                c,
                                                                                                "active",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "c.active",
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      c.key ===
                                                                      "dtes"
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mt-n7",
                                                                            },
                                                                            _vm._l(
                                                                              _vm.currentDocumentListGroup,
                                                                              function (
                                                                                doc,
                                                                                i
                                                                              ) {
                                                                                return _c(
                                                                                  "v-list-item",
                                                                                  {
                                                                                    key: i,
                                                                                    staticClass:
                                                                                      "pa-0",
                                                                                    attrs:
                                                                                      {
                                                                                        inactive:
                                                                                          "",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-list-item-title",
                                                                                      {
                                                                                        staticClass:
                                                                                          "grey-300--text",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            doc.name
                                                                                          ) +
                                                                                            " "
                                                                                        ),
                                                                                        doc.name.includes(
                                                                                          "Ver"
                                                                                        ) &&
                                                                                        _vm
                                                                                          .currentDocumentListGroup[
                                                                                          i -
                                                                                            1
                                                                                        ]
                                                                                          .active
                                                                                          ? _c(
                                                                                              "v-chip",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "caption pa-2",
                                                                                                attrs:
                                                                                                  {
                                                                                                    color:
                                                                                                      "blue-50",
                                                                                                    "text-color":
                                                                                                      "blue-200",
                                                                                                    "x-small":
                                                                                                      "",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Obligatorio, si la opción " +
                                                                                                    _vm._s(
                                                                                                      _vm.currentDocumentListGroup[
                                                                                                        i -
                                                                                                          1
                                                                                                      ].name.toLowerCase()
                                                                                                    ) +
                                                                                                    " está activa"
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                    _c(
                                                                                      "v-list-item-subtitle",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mr-0",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-switch",
                                                                                          {
                                                                                            staticClass:
                                                                                              "mt-n1",
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "green-500",
                                                                                                ripple: false,
                                                                                                dense:
                                                                                                  "",
                                                                                                disabled:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  _vm.enabledTooltip(
                                                                                                    doc,
                                                                                                    i,
                                                                                                    index
                                                                                                  ),
                                                                                                    (item.selectOrDeselectAllPermission =
                                                                                                      _vm.currentDocumentListGroup.every(
                                                                                                        (
                                                                                                          item
                                                                                                        ) =>
                                                                                                          item.active
                                                                                                      ))
                                                                                                },
                                                                                            },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  doc.active,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      doc,
                                                                                                      "active",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "doc.active",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              }
                                                                            ),
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.list.length - 1 !== i
                                                ? _c("v-divider")
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("v-empty-state", {
                              attrs: {
                                type: "suppliers",
                                id: "miembros",
                                isFree: true,
                                title: "No existen usuarios",
                              },
                            }),
                      ],
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        to: {
                          name: "AccountGroupsUpdate",
                          params: { id: _vm.currentGroup.id },
                        },
                        target: "_blank",
                        outlined: "",
                      },
                    },
                    [_vm._v("Editar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.handlerGroupDialog },
                    },
                    [_vm._v("Cerrar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }